angular.module('cfn').factory('stockService', stockService);

stockService.$inject = ['$http', '$q'];

function stockService($http, $q) {
  // Private
  var STOCK_URL = '/365FarmNet/rest/core/stockyard/inventory';

  // create and add distinct stockType-Array to data for grouping
  function transformResponse(data) {
    data.stockTypes = [];
    if (data.list)
      data.list.map(function(element) {
        element.url = element.stocktype.toLowerCase();
        if (element.stocktype === 'PlantProtectant')
          element.url = 'plantProtectant';

        // prepare for new entry
        element.newInventory = element.inventory;
        element.newUnit = element.unit;
        if (data.stockTypes.indexOf(element.stocktype) == -1)
          data.stockTypes.push(element.stocktype);
      });
    return data;
  }

  // create BE-inventorylist with changed values
  function transformRequest(list, date) {
    return list
      .filter(function(v) {
        // only changed values
        return v.inventory != v.newInventory || v.unit != v.newUnit;
      })
      .map(function(v) {
        // only properties for BE
        return {
          id: v.id,
          inventory: v.newInventory,
          unit: v.newUnit,
          date: date
        };
      });
  }

  // Public
  return {
    /**
     * return Url for Testing
     */
    url: function() {
      return STOCK_URL;
    },

    /**
     * GET Reportdata for date
     * @returns Promise
     */
    loadData: function(date) {
      var params = {
        bookingdate: date || new Date().getTime()
      };

      return $http.get(STOCK_URL, { params: params }).then(function(response) {
        return transformResponse(response.data);
      });
    },

    /**
     * POST Reportdata for booking
     * @returns Promise
     */
    saveData: function(list, date) {
      var changeList = transformRequest(list, date);
      if (changeList.length > 0) {
        console.debug(changeList);
        return $http.post(STOCK_URL, changeList);
      } else return $q.when(changeList);
    }
  };
}

export default stockService;
